(() => {
  const formatMoney = (cents, symbol) => {
    const locale = document.documentElement.lang || undefined;
    return `${(cents / 100).toLocaleString(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })} ${symbol}`.trim();
  };

  const initBundle = (container) => {
    if (!container || container.dataset.siteConnected === "true") return;

    const items = Array.from(container.querySelectorAll("[data-bundle-item]"));
    const addButton = container.querySelector("[data-bundle-add]");
    const total = container.querySelector("[data-bundle-total]");
    const error = container.querySelector("[data-bundle-error]");
    const selections = new Map();

    const update = () => {
      const complete = selections.size === items.length;

      addButton.disabled = !complete;
      addButton.setAttribute("aria-disabled", String(!complete));

      if (complete) {
        const amount = Array.from(selections.values()).reduce(
          (sum, selection) => sum + selection.price,
          0
        );
        total.textContent = formatMoney(amount, container.dataset.currencySymbol);
      } else {
        total.textContent = `0,00 ${container.dataset.currencySymbol}`.trim();
      }
    };

    container.addEventListener("click", async (event) => {
      const variantButton = event.target.closest("[data-bundle-variant]");
      if (variantButton) {
        if (variantButton.classList.contains("is-sold-out")) return;
        const item = variantButton.closest("[data-bundle-item]");
        item.querySelectorAll("[data-bundle-variant]").forEach((button) => {
          button.classList.toggle("is-active", button === variantButton);
          button.setAttribute("aria-pressed", String(button === variantButton));
        });
        selections.set(item, {
          id: Number(variantButton.dataset.variantId),
          price: Number(variantButton.dataset.price)
        });
        error.hidden = true;
        update();
        return;
      }

      if (!event.target.closest("[data-bundle-add]")) return;
      if (selections.size !== items.length) {
        error.textContent = container.dataset.errorSelect;
        error.hidden = false;
        return;
      }

      const label = addButton.querySelector("span");
      addButton.disabled = true;
      addButton.setAttribute("aria-disabled", "true");
      label.textContent = container.dataset.labelAdding;

      try {
        const cartDrawer = document.querySelector("cart-drawer");
        const sections = cartDrawer
          ? cartDrawer.getSectionsToRender().map((section) => section.id)
          : [];
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify({
            items: Array.from(selections.values()).map(({ id }) => ({ id, quantity: 1 })),
            sections,
            sections_url: window.location.pathname
          })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description);

        label.textContent = container.dataset.labelAdded;
        if (cartDrawer && result.sections) {
          cartDrawer.setActiveElement(addButton);
          cartDrawer.renderContents(result);
        } else {
          window.location.assign(`${window.Shopify.routes.root}cart`);
        }
      } catch (caughtError) {
        error.textContent = caughtError.message || container.dataset.errorGeneral;
        error.hidden = false;
        label.textContent = container.dataset.labelAdd;
        addButton.disabled = false;
        addButton.setAttribute("aria-disabled", "false");
      }
    });

    update();
    container.dataset.siteConnected = "true";
  };

  const init = (root = document) => {
    root.querySelectorAll("[data-site-product-bundle]").forEach(initBundle);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
